'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/11/4.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AccordionComponent, _Component);

  function AccordionComponent() {
    (0, _classCallCheck3.default)(this, AccordionComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AccordionComponent).call(this));

    _this.state = {
      designerShowID: 0
    };
    return _this;
  }

  (0, _createClass3.default)(AccordionComponent, [{
    key: 'onDesignerMouseOver',
    value: function onDesignerMouseOver(designerId) {
      if (this.state.designerShowID !== designerId) {
        this.setState({
          designerShowID: designerId
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./AccordionComponent.scss');
      var designerShowID = this.state.designerShowID;
      var _props = this.props;
      var images = _props.images;
      var type = _props.type;

      var minWidth = void 0;
      var maxWidth = void 0;
      if (images instanceof Array && images.length > 0) {
        switch (images.length) {
          case 1:
            minWidth = '100%';
            maxWidth = '100%';
            break;
          case 2:
            minWidth = '30%';
            maxWidth = '70%';
            break;
          case 3:
            minWidth = '25%';
            maxWidth = '50%';
            break;
          case 4:
            minWidth = '20%';
            maxWidth = '40%';
            break;
          case 5:
            minWidth = '15%';
            maxWidth = '40%';
            break;
          case 6:
            minWidth = '12%';
            maxWidth = '40%';
            break;
          case 7:
            minWidth = '10%';
            maxWidth = '40%';
            break;
          default:
            minWidth = '10%';
            maxWidth = '40%';
            break;
        }
      }
      var content = '';
      if (images instanceof Array) {
        if (images.length > 1) {
          if (type === 'preview') {
            content = images.map(function (item, index) {
              var result = void 0;
              if (index < 7) {
                result = _react2.default.createElement(
                  'li',
                  { style: { width: designerShowID === index ? maxWidth : minWidth }, key: item.id,
                    onMouseOver: function onMouseOver() {
                      return _this2.onDesignerMouseOver(index);
                    } },
                  _react2.default.createElement(
                    'a',
                    null,
                    _react2.default.createElement('img', { src: item.img, title: item.name })
                  )
                );
              } else {
                result = false;
              }
              return result;
            });
          } else {
            content = images.map(function (item, index) {
              var result = void 0;
              if (index < 7) {
                result = _react2.default.createElement(
                  'li',
                  { style: { width: designerShowID === index ? maxWidth : minWidth }, key: item.id,
                    onMouseOver: function onMouseOver() {
                      return _this2.onDesignerMouseOver(index);
                    } },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' + type + '/' + item.id, target: '_blank' },
                    _react2.default.createElement('img', { src: item.img, title: item.name })
                  )
                );
              } else {
                result = false;
              }
              return result;
            });
          }
        } else if (images.length === 1) {
          if (type === 'preview') {
            content = _react2.default.createElement(
              'li',
              { style: { width: '100%' } },
              _react2.default.createElement(
                'a',
                null,
                _react2.default.createElement('img', { style: { width: '100%', height: '100%' },
                  src: images[0].img,
                  title: images[0].name })
              )
            );
          } else {
            content = _react2.default.createElement(
              'li',
              { style: { width: '100%' } },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/' + type + '/' + images[0].id, target: '_blank' },
                _react2.default.createElement('img', { style: { width: '100%', height: '100%' },
                  src: images[0].img,
                  title: images[0].name })
              )
            );
          }
        }
      }
      return _react2.default.createElement(
        'ul',
        { className: styles.component },
        content
      );
    }
  }]);
  return AccordionComponent;
}(_react.Component), _class.propTypes = {
  images: _react.PropTypes.array,
  type: _react.PropTypes.string
}, _temp);
exports.default = AccordionComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AccordionComponent/AccordionComponent.js
 ** module id = 1304
 ** module chunks = 0
 **/